// src/constants.ts - Enhanced with better performance constants
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.ppl.contact';
export const CACHE_DURATION = 2 * 60 * 1000; // 2 minutes
export const DEBOUNCE_DELAY = 300; // 300ms debounce for user input

// Schema and metadata caching
export const SCHEMA_CACHE_DURATION = 10 * 60 * 1000; // 10 minutes
export const SCHEMA_RETRY_ATTEMPTS = 3;
export const METADATA_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// ENHANCED: Billing-specific constants
export const BILLING_POLL_INTERVAL = 5000; // 5 seconds for real-time updates
export const BILLING_RETRY_DELAY = 5000; // 5 seconds
export const MIN_BILLING_AMOUNT = 1;
export const MAX_BILLING_AMOUNT = 1000;

// Request timeouts
export const DEFAULT_REQUEST_TIMEOUT = 30000; // 30 seconds
export const HEALTH_CHECK_TIMEOUT = 10000; // 10 seconds
export const SCHEMA_REQUEST_TIMEOUT = 15000; // 15 seconds
export const BILLING_REQUEST_TIMEOUT = 20000; // 20 seconds

// UI performance constants
export const MAX_VISIBLE_ROWS = 1000;
export const VIRTUAL_SCROLL_THRESHOLD = 100;
export const SEARCH_MIN_CHARS = 2;

// Rate limiting
export const RATE_LIMIT_RETRY_DELAY = 5000;
export const MAX_RETRY_ATTEMPTS = 3;
export const EXPONENTIAL_BACKOFF_BASE = 1000;

// Feature flags
export const FEATURES = {
  ENABLE_CACHING: true,
  ENABLE_VIRTUAL_SCROLL: true,
  ENABLE_BACKGROUND_SYNC: true,
  ENABLE_OFFLINE_MODE: false,
  ENABLE_ANALYTICS: true,
  ENABLE_BILLING: true, // NEW
  ENABLE_DEBUG_LOGS: import.meta.env.MODE === 'development'
} as const;

// Performance monitoring
export const PERFORMANCE_THRESHOLDS = {
  SEARCH_TIME_WARNING: 2000,
  METADATA_TIME_WARNING: 5000,
  RENDER_TIME_WARNING: 100,
  MEMORY_USAGE_WARNING: 100 * 1024 * 1024,
  BILLING_UPDATE_WARNING: 3000 // NEW
} as const;

// Environment-specific settings
export const IS_PRODUCTION = import.meta.env.MODE === 'production';
export const IS_DEVELOPMENT = import.meta.env.MODE === 'development';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

// Security settings
export const SECURITY = {
  MAX_API_KEY_LENGTH: 256,
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000,
  CSRF_PROTECTION: true,
  SECURE_COOKIES: IS_PRODUCTION
} as const;